import RichTextEditor from 'react-rte';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Avatar } from "@mui/material";
import logo_icon from '../../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { api_urls } from '../../../../utils/api-urls/index.js';
import * as CategoryActions from '../../../../redux/actions/categoryAction.js';
import * as SubCategoryActions from '../../../../redux/actions/subCategoryAction.js';
import * as SancharActions from '../../../../redux/actions/sancharAction';

const AddNews = ({ mode }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location?.state?.stateData;
  console.log(stateData);

  const { categoryData } = useSelector(state => state.categoryReducer);
  const { subCategoryData, subCatgeoryDataByCategoryId } = useSelector(state => state.subCategoryReducer);
  const redirectCategoryData = categoryData.filter(value => value?.redirect_page === 'News');   //* Redirect Category Data For Category Name Option

  const [newsDetail, setNewsDetail] = useState({ categoryId: stateData ? stateData?.newsCategoryId?._id : '', subCategoryId: stateData ? stateData?.newsubCategoryId?._id : '', authorName: stateData ? stateData?.author : '', newsTitle: stateData ? stateData?.title : '' });
  const [description, setDescription] = useState(stateData ? RichTextEditor.createValueFromString(String(stateData?.details), 'html') : RichTextEditor.createEmptyValue());
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', authorName: '', image: '', newsTitle: '', description: '' });
  const [image, setImage] = useState({ file: stateData ? api_urls + stateData?.image : logo_icon, bytes: "" });

  const [breakingNews, setBreakingNews] = useState(stateData ? stateData?.breaking_news : false);

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setNewsDetail({ ...newsDetail, [name]: value });
  };

  //* Handle Image
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  //! Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { categoryId, subCategoryId, authorName, newsTitle } = newsDetail;
    const { file } = image;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryId) {
      handleInputFieldError("subCategoryId", "Please Select Sub Category Name")
      isValid = false;
    }
    if (!authorName) {
      handleInputFieldError("authorName", "Please Enter Author Name")
      isValid = false;
    }
    if (!file) {
      handleInputFieldError("image", "Please Select Image")
      isValid = false;
    }
    if (!newsTitle) {
      handleInputFieldError("newsTitle", "Please Enter New Title")
      isValid = false;
    }
    if (!description) {
      handleInputFieldError("description", "Please Enter News Description")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating News
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("News Data :: ", { ...newsDetail, breakingNews, image, description });
      const { categoryId, subCategoryId, authorName, newsTitle } = newsDetail;

      if (stateData) {
        let formData = new FormData();
        formData.append("newsId", stateData?._id);
        formData.append("newsCategoryId", categoryId);
        formData.append("newsubCategoryId", subCategoryId);
        formData.append("author", authorName);
        formData.append("title", newsTitle);
        formData.append("details", description?.toString('html'));
        formData.append("breaking_news", breakingNews);
        formData.append("image", image?.bytes);

        const payload = {
          data: formData,
          onComplete: () => navigate("/news")
        }

        //! Dispatching API for Creating News
        dispatch(SancharActions.updateNews(payload));
      } else {
        let formData = new FormData();
        formData.append("newsCategoryId", categoryId);
        formData.append("newsubCategoryId", subCategoryId);
        formData.append("author", authorName);
        formData.append("title", newsTitle);
        formData.append("details", description?.toString('html'));
        formData.append("breaking_news", breakingNews);
        formData.append("image", image?.bytes);

        const payload = {
          data: formData,
          onComplete: () => navigate("/news")
        }

        //! Dispatching API for Creating News
        dispatch(SancharActions.createNews(payload));
      }
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(CategoryActions.getCategory())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Sub Category
    newsDetail?.categoryId && dispatch(SubCategoryActions.getSubCategoryByCategoryId({ categoryId: newsDetail?.categoryId }))
  }, [newsDetail?.categoryId]);

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>{mode} News</div>
          <div onClick={() => navigate("/news")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={newsDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category---</MenuItem>
                {redirectCategoryData.map((value, index) => <MenuItem key={index} value={value?._id}>{value?.category_name}</MenuItem>)}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Sub Category</InputLabel>
              <Select
                label="Select Sub Category" variant="outlined" fullWidth
                name='subCategoryId'
                value={newsDetail?.subCategoryId}
                onChange={handleInputField}
                error={inputFieldError?.subCategoryId ? true : false}
                onFocus={() => handleInputFieldError("subCategoryId", null)}
              >
                {subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                {subCatgeoryDataByCategoryId && subCatgeoryDataByCategoryId.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : subCatgeoryDataByCategoryId?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.sub_category_name}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="News Title" variant='outlined' fullWidth
              name='newsTitle'
              value={newsDetail?.newsTitle}
              onChange={handleInputField}
              error={inputFieldError.newsTitle ? true : false}
              helperText={inputFieldError.newsTitle}
              onFocus={() => handleInputFieldError("newsTitle", null)}
            />
          </Grid>

          <Grid item lg={6} sm={6} md={12} xs={12} >
            <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }}>
              <Grid item xs={2} >
                <Avatar src={image.file} style={{ width: 40, height: 40 }} />
              </Grid>
              <Grid component="label" item xs={10} style={{ backgroundColor: "#E2E8F0", textAlign: "center", color: "#666666", padding: "10px 30px", borderRadius: "20px", cursor: "pointer", fontWeight: "500", fontSize: "14px" }}>
                Upload News Image
                <input onChange={handleImage} hidden accept="image/*" type="file" />
              </Grid>
            </Grid>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "10px 0 0 15px" }}>{inputFieldError?.image}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Author Name" variant='outlined' fullWidth
              name='authorName'
              value={newsDetail?.authorName}
              onChange={handleInputField}
              error={inputFieldError.authorName ? true : false}
              helperText={inputFieldError.authorName}
              onFocus={() => handleInputFieldError("authorName", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} xs={12} >
            <div style={{ display: "flex", gap: "20px", border: "1px solid #C4C4C4", padding: "16px 13.5px", borderRadius: "5px" }}>
              <label style={{ cursor: "pointer", color: "#666666", fontFamily: "Philosopher", fontSize: "13.5px", color: "#667284" }} htmlFor="layout-template">Breaking News</label>
              <input defaultChecked={breakingNews} onClick={(e) => setBreakingNews(e.target.checked)} style={{ cursor: "pointer", marginTop: "0px", padding: "0px" }} id='layout-template' type="checkbox" />
            </div>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <RichTextEditor
              value={description}
              onChange={setDescription}
              editorStyle={{ minHeight: '50vh', }}
              onFocus={() => handleInputFieldError("description", null)}
            />
            {inputFieldError?.description && <div style={{ color: "#D32F2F", fontSize: "13px", padding: "5px 15px 0 12px", fontWeight: "400" }}>{inputFieldError?.description}</div>}
          </Grid>


          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default AddNews;